var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTraitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596168",
    fillRule: "evenodd",
    d: "M5.268 9a2 2 0 013.464 0H15a1 1 0 010 2H8.732a2 2 0 01-3.464 0H1a1 1 0 010-2h4.268zm5-4a2 2 0 013.464 0H15a1 1 0 010 2h-1.268a2 2 0 01-3.464 0H1a1 1 0 110-2h9.268zm-6-4a2 2 0 013.464 0H15a1 1 0 010 2H7.732a2 2 0 01-3.464 0H1a1 1 0 110-2h3.268z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraitIcon);
export default ForwardRef;